import styled from 'styled-components';

export default styled.section`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-large);
	div {
		display: flex;
		gap: var(--spacing-large);
		.no-shrink {
			flex-shrink: 0;
		}
	}
`;
